import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EndUserTypeForReport } from "../types/EndUserTypeForReport";
import { apiClient } from "src/utils/Api/apiClient";


interface endUserForReportState {
        endUserForReports: Array<EndUserTypeForReport>;
        endUserForReportsLoading: boolean;
        endUserForReportsError: string | null;
}

const initialState: endUserForReportState = {
        endUserForReports: [],
        endUserForReportsLoading: false,
        endUserForReportsError: null
}

export const getEndUsersByDealerIDForReports = createAsyncThunk(
        'endUser/getEndUsersByDealerIDForReports',
        async (endUserData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.get(`endUser/getEndUsersByDealerIDForReports/${endUserData}`);
                        return response.data;
                } catch (error: any) {
                        return rejectWithValue(error.message || 'An error occured');
                }
        }
);


const endUserForReportsSlice = createSlice({
        name: 'endUserForReports',
        initialState,
        reducers: {
                endUserForReportsReset: () => initialState,
        },
        extraReducers: (builder) => {
                //get all endUsers from server by dealer id
                builder.addCase(getEndUsersByDealerIDForReports.pending, (state) => {
                        state.endUserForReportsLoading = true;
                        state.endUserForReportsError = null;
                });
                builder.addCase(getEndUsersByDealerIDForReports.fulfilled, (state, action) => {
                        state.endUserForReportsLoading = false;
                        state.endUserForReports = action.payload;
                });
                builder.addCase(getEndUsersByDealerIDForReports.rejected, (state, action) => {
                        state.endUserForReportsLoading = false;
                        state.endUserForReportsError = action.payload as string;
                });

        }
});

export const { endUserForReportsReset } = endUserForReportsSlice.actions;
export default endUserForReportsSlice.reducer;
